import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Cars24CoverWrapper from "./component";
import { getServicingPriceConfig } from "../add-ons/actions";

const mapStateToProps = ({
    carDetails: {content},
    checkout: {
        order
    },
    addOns: {
        servicingPriceConfig
    },
    abExperiment: {
        desktopProductPitching
    }
}) => ({
    servicingPriceConfig,
    desktopProductPitching,
    content,
    order
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getServicingPriceConfigConnect: getServicingPriceConfig
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Cars24CoverWrapper);
